// Chart patterns — RE₿EL LLM pipeline translation (Sprint B).
// tipo/direccion/nivel keys preserved from ES for filter consistency.

export const PATRONES = [
  {
    id: "bandera-alcista",
    nombre: "Bullische Flagge",
    tipo: "continuacion",
    direccion: "alcista",
    nivel: "basico",
    descripcion: "Bullisches Fortsetzungsmuster, das durch einen starken Aufwärtsimpuls (die Fahnenstange) gefolgt von einer Korrektur in einem parallelen Abwärtskanal (die Flagge) gebildet wird. Zeigt eine Pause an, bevor der Trend nach oben fortsetzt.",
    estructura: [
      "Fahnenstange: starker bullischer Impuls",
      "Paralleler bärischer Korrekturkanal (die Flagge)",
      "Ausbruch nach oben aus dem Kanal mit Volumen"
    ],
    objetivo: "Die Höhe der Fahnenstange, projiziert nach oben vom Ausbruchspunkt.",
    consejo: "Achte auf abnehmendes Volumen während der Flagge und Zunahme beim Ausbruch. Zuverlässiger in 4H- oder Tages-Zeitrahmen. Sehr häufig bei BTC nach positiven Nachrichten."
  },
  {
    id: "bandera-bajista",
    nombre: "Bärische Flagge",
    tipo: "continuacion",
    direccion: "bajista",
    nivel: "basico",
    descripcion: "Bärisches Fortsetzungsmuster. Ein starker Abwärtsimpuls (Fahnenstange) gefolgt von einer Aufwärtskorrektur in einem parallelen Kanal (Flagge). Signal für Fortsetzung des Abwärtstrends.",
    estructura: [
      "Fahnenstange: starker bärischer Impuls",
      "Paralleler bullischer Korrekturkanal",
      "Ausbruch nach unten aus dem Kanal"
    ],
    objetivo: "Die Höhe der Fahnenstange, projiziert nach unten vom Ausbruchspunkt.",
    consejo: "Der Korrekturkanal sollte unter 50% der Fahnenstange bleiben. Überschreitet er dieses Niveau, verliert das Muster an Zuverlässigkeit."
  },
  {
    id: "banderin-alcista",
    nombre: "Bullischer Wimpel",
    tipo: "continuacion",
    direccion: "alcista",
    nivel: "basico",
    descripcion: "Ähnlich der bullischen Flagge, aber die Korrektur bildet ein konvergierendes Dreieck statt eines parallelen Kanals. Die Konsolidierung ist kompakter und der Ausbruch meist explosiver.",
    estructura: [
      "Fahnenstange: bullischer Impuls",
      "Konvergierendes Konsolidierungsdreieck",
      "Ausbruch nach oben aus dem Dreieck"
    ],
    objetivo: "Die Höhe der Fahnenstange, projiziert vom Scheitelpunkt des Dreiecks nach oben.",
    consejo: "Das Dreieck sollte sich in der oberen Hälfte der Fahnenstange bilden. Je näher am Scheitelpunkt der Ausbruch erfolgt, desto kraftvoller ist meist die Bewegung."
  },
  {
    id: "banderin-bajista",
    nombre: "Bärischer Wimpel",
    tipo: "continuacion",
    direccion: "bajista",
    nivel: "basico",
    descripcion: "Bärische Version des Wimpels. Das konvergierende Dreieck bildet sich nach einem starken bärischen Impuls. Fortsetzungssignal: der Ausbruch nach unten bestätigt die Bewegung.",
    estructura: [
      "Fahnenstange: bärischer Impuls",
      "Konvergierendes Konsolidierungsdreieck",
      "Ausbruch nach unten aus dem Dreieck"
    ],
    objetivo: "Die Höhe der Fahnenstange, projiziert nach unten vom Scheitelpunkt.",
    consejo: "Bestätige mit zunehmendem Volumen beim Ausbruch. Wimpel in kurzen Zeitrahmen (15min-1H) sind sehr häufig in Krypto."
  },
  {
    id: "taza-asa",
    nombre: "Tasse mit Henkel",
    tipo: "continuacion",
    direccion: "alcista",
    nivel: "intermedio",
    descripcion: "Sanfte U-förmige Korrektur (die Tasse), gefolgt von einer kleinen bärischen Konsolidierung (der Henkel). Eines der am meisten studierten Muster in Aufwärtstrends.",
    estructura: [
      "Vorheriger Aufwärtsimpuls",
      "U-förmige Korrektur (die Tasse)",
      "Kleine bärische Korrektur (der Henkel)",
      "Ausbruch über den Widerstand"
    ],
    objetivo: "Die Tiefe der Tasse, projiziert nach oben vom Widerstandsniveau.",
    consejo: "Die Tasse sollte abgerundet sein (U), nicht V-förmig. Der Henkel sollte nicht mehr als 50% der Tasse korrigieren. Sehr häufig bei BTC in Wochen-Timeframes."
  },
  {
    id: "taza-asa-invertida",
    nombre: "Umgekehrte Tasse mit Henkel",
    tipo: "continuacion",
    direccion: "bajista",
    nivel: "intermedio",
    descripcion: "Bärische Version. Die Korrektur bildet eine umgekehrte Kuppel, gefolgt von einer kleinen bullischen Korrektur. Signal für bärische Fortsetzung.",
    estructura: [
      "Vorheriger Abwärtsimpuls",
      "Umgekehrte U-förmige Korrektur (Kuppel)",
      "Kleine bullische Korrektur (Henkel)",
      "Bärischer Bruch der Unterstützung"
    ],
    objetivo: "Die Tiefe der Kuppel, projiziert nach unten von der Unterstützung.",
    consejo: "Häufig in verlängerten Abwärtstrends. Mit zunehmendem Volumen beim Abwärtsbruch bestätigen."
  },
  {
    id: "doble-techo",
    nombre: "Doppeltop",
    tipo: "reversion",
    direccion: "bajista",
    nivel: "basico",
    descripcion: "Zwei aufeinanderfolgende Hochs auf demselben Niveau mit einem dazwischenliegenden Tief. Signal, dass die Käufer diesen Widerstand nicht überwinden können. Der Bruch unter die Nackenlinie bestätigt die Umkehr.",
    estructura: [
      "Erstes Hoch",
      "Korrektur bis zur Nackenlinie",
      "Zweites Hoch auf demselben Niveau",
      "Bärischer Bruch der Nackenlinie"
    ],
    objetivo: "Distanz zwischen dem Hoch und der Nackenlinie, nach unten projiziert.",
    consejo: "Das zweite Hoch mit geringerem Volumen erhöht die Zuverlässigkeit. Mit Schlusskurs unter der Nackenlinie bestätigen."
  },
  {
    id: "doble-suelo",
    nombre: "Doppelboden",
    tipo: "reversion",
    direccion: "alcista",
    nivel: "basico",
    descripcion: "Zwei aufeinanderfolgende Tiefs auf demselben Niveau mit einem dazwischenliegenden Hoch. Die Verkäufer können den Preis nicht unter diese Unterstützung drücken. Bullischer Bruch der Nackenlinie bestätigt die Umkehr.",
    estructura: [
      "Erstes Tief",
      "Erholung bis zur Nackenlinie",
      "Zweites Tief auf demselben Niveau",
      "Bullischer Bruch der Nackenlinie"
    ],
    objetivo: "Distanz zwischen dem Tief und der Nackenlinie, nach oben projiziert.",
    consejo: "Zweites Tief mit geringerem Volumen ist ein positives Signal. Mit Schlusskurs über der Nackenlinie bestätigen."
  },
  {
    id: "triple-techo",
    nombre: "Triple Top",
    tipo: "reversion",
    direccion: "bajista",
    nivel: "intermedio",
    descripcion: "Drei Hochs auf demselben Niveau. Zuverlässiger als das Doppeltop. Jeder gescheiterte Versuch, den Widerstand zu überwinden, erhöht den Verkaufsdruck.",
    estructura: [
      "Drei aufeinanderfolgende Hochs auf demselben Niveau",
      "Zwei Zwischenkorrekturen",
      "Bruch unter die Nackenlinie"
    ],
    objetivo: "Abstand zwischen dem Hoch und der Nackenlinie, nach unten projiziert.",
    consejo: "Je länger die Formation braucht, desto stärker ist in der Regel der anschließende Rückgang."
  },
  {
    id: "triple-suelo",
    nombre: "Triple Bottom",
    tipo: "reversion",
    direccion: "alcista",
    nivel: "intermedio",
    descripcion: "Drei Tiefs auf demselben Niveau. Eines der stärksten bullischen Umkehrsignale. Die Unterstützung wird mit jedem Rückprall verstärkt.",
    estructura: [
      "Drei aufeinanderfolgende Tiefs auf demselben Niveau",
      "Zwei Zwischenrückpraller",
      "Bruch über die Nackenlinie"
    ],
    objetivo: "Abstand zwischen dem Tief und der Nackenlinie, nach oben projiziert.",
    consejo: "Bei Krypto markieren Triple Bottoms an langfristiger Unterstützung häufig wichtige Marktböden."
  },
  {
    id: "cabeza-hombros",
    nombre: "Kopf-Schulter-Formation",
    tipo: "reversion",
    direccion: "bajista",
    nivel: "basico",
    descripcion: "Das bekannteste Umkehrmuster. Drei Hochs: das mittlere (Kopf) übersteigt die beiden äußeren (Schultern), die auf demselben Niveau liegen. Der Bruch unter die Nackenlinie bestätigt die bärische Umkehr.",
    estructura: [
      "Linke Schulter",
      "Kopf (höheres Hoch)",
      "Rechte Schulter (≈gleiches Niveau wie die linke)",
      "Nackenlinie + bärischer Bruch"
    ],
    objetivo: "Abstand zwischen Kopf und Nackenlinie, vom Bruch aus projiziert.",
    consejo: "Eine nach oben geneigte Nackenlinie ist bärischer. Hohes Volumen beim Bruch bestätigt das Muster."
  },
  {
    id: "cabeza-hombros-inversos",
    nombre: "Inverse Kopf-Schulter-Formation",
    tipo: "reversion",
    direccion: "alcista",
    nivel: "basico",
    descripcion: "Bullische Version der Kopf-Schulter-Formation. Drei Tiefs, wobei das mittlere (Kopf) das tiefste ist. Der Bruch über die Nackenlinie signalisiert eine starke bullische Umkehr.",
    estructura: [
      "Linke Schulter",
      "Kopf (tieferes Tief)",
      "Rechte Schulter (≈gleiches Niveau wie die linke)",
      "Nackenlinie + bullischer Bruch"
    ],
    objetivo: "Abstand zwischen Kopf und Nackenlinie, nach oben projiziert.",
    consejo: "Eines der zuverlässigsten Muster zur Identifizierung von Böden. Achte auf steigendes Volumen bei der rechten Schulter und beim Bruch."
  },
  {
    id: "cuna-ascendente",
    nombre: "Aufsteigender Keil",
    tipo: "reversion",
    direccion: "bajista",
    nivel: "intermedio",
    descripcion: "Konvergierender Kanal mit Aufwärtsneigung. Beide Linien steigen, konvergieren jedoch: Der Preis hat zunehmend weniger Raum nach oben. Signal für bärische Umkehr.",
    estructura: [
      "Aufwärts gerichtete Widerstandslinie",
      "Aufwärts gerichtete Unterstützungslinie (mit steilerer Neigung)",
      "Konvergenz beider Linien",
      "Ausbruch nach unten"
    ],
    objetivo: "Höhe der Keilbasis, projiziert nach unten vom Ausbruchspunkt.",
    consejo: "Aufsteigende Keile erscheinen häufig am Ende bullischer Impulse. Sie sind Signale für institutionelle Verteilung."
  },
  {
    id: "cuna-descendente",
    nombre: "Absteigender Keil",
    tipo: "reversion",
    direccion: "alcista",
    nivel: "intermedio",
    descripcion: "Konvergierender Kanal mit Abwärtsneigung. Der Verkaufsdruck nimmt mit jedem Tief ab. Signal für bullische Umkehr: Der Ausbruch nach oben ist meist kraftvoll.",
    estructura: [
      "Abwärts gerichtete Widerstandslinie",
      "Abwärts gerichtete Unterstützungslinie (mit geringerer Neigung)",
      "Konvergenz beider Linien",
      "Ausbruch nach oben"
    ],
    objetivo: "Höhe der Keilbasis, projiziert nach oben vom Ausbruchspunkt.",
    consejo: "Absteigende Keile in Korrekturen eines Aufwärtstrends sind sehr zuverlässige Fortsetzungssignale bei BTC/ETH."
  },
  {
    id: "triangulo",
    nombre: "Symmetrisches Dreieck",
    tipo: "neutro",
    direccion: "neutro",
    nivel: "basico",
    descripcion: "Konsolidierungszone mit fallenden Hochs und steigenden Tiefs. Der Preis wird komprimiert, bis die Energie einen Ausbruch erzeugt. Die Richtung des Ausbruchs bestimmt das Ziel.",
    estructura: [
      "Abwärts gerichtete Widerstandslinie",
      "Aufwärts gerichtete Unterstützungslinie",
      "Konvergenz zu einem Scheitelpunkt",
      "Ausbruch (Richtung unbestimmt)"
    ],
    objetivo: "Höhe der Dreiecksbasis, projiziert in Richtung des Ausbruchs.",
    consejo: "Der Kontext bestimmt die Wahrscheinlichkeit: Ein Dreieck in einem Aufwärtstrend bricht meist nach oben aus. Bestätige immer mit Kerzenschluss außerhalb."
  },
  {
    id: "rectangulo",
    nombre: "Rechteck",
    tipo: "neutro",
    direccion: "neutro",
    nivel: "basico",
    descripcion: "Der Preis oszilliert zwischen horizontaler Unterstützung und Widerstand. Zone der Akkumulation oder Verteilung. Die Richtung des Ausbruchs bestimmt die Tendenz und das Ziel.",
    estructura: [
      "Horizontaler Widerstand",
      "Horizontale Unterstützung",
      "Oszillationen zwischen beiden",
      "Ausbruch (Richtung unbestimmt)"
    ],
    objetivo: "Höhe des Rechtecks, projiziert in Richtung des Ausbruchs.",
    consejo: "In Krypto gehen lange Rechtecke mit steigendem Volumen an den Tiefs meist kraftvollen bullischen Ausbrüchen voraus (institutionelle Akkumulation)."
  }
];

export const TIPOS = ["continuacion", "reversion", "neutro"];
export const NIVELES = ["basico", "intermedio"];

export const TIPO_LABEL = {
  continuacion: "Fortsetzung",
  reversion: "Umkehr",
  neutro: "Neutral",
};

export const DIRECCION_LABEL = {
  alcista: "Aufwärts",
  bajista: "Abwärts",
  neutro: "Neutral",
};

export const NIVEL_LABEL = {
  basico: "Grundlagen",
  intermedio: "Mittel",
};

export function getPatron(id) {
  return PATRONES.find((p) => p.id === id) || null;
}

export function filtrarPatrones(tipo, nivel) {
  return PATRONES.filter((p) => {
    const okTipo = !tipo || tipo === "todos" || p.tipo === tipo;
    const okNivel = !nivel || nivel === "todos" || p.nivel === nivel;
    return okTipo && okNivel;
  });
}
